module.exports = __webpack_public_path__ + "img/UnOpenBG.91b1a435.png";